import { render, staticRenderFns } from "./TaskFilterItem.vue?vue&type=template&id=21bfdc4c&scoped=true"
import script from "./TaskFilterItem.vue?vue&type=script&lang=js"
export * from "./TaskFilterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bfdc4c",
  null
  
)

export default component.exports